import { AchievementCarousel } from "@components/AchievementCarousel";
import { Footer } from "@components/Footer";
import { HighscoreTable } from "@components/HighscoreTable";
import { Loading } from "@components/Loading";
import { TopNav } from "@components/TopNav";
import { useEvent, useEventId } from "@helpers/useEvent";
import { useSimpleCollection } from "@helpers/useSimpleCollection";
import { useTeamId } from "@helpers/useTeam";
import { useTranslation } from "@helpers/useTranslation";
import { FC, useEffect, useState } from "react";

type Props = {
  isAdmin: boolean;
};

export const Highscores: FC<Props> = ({ isAdmin }) => {
  const { t } = useTranslation("highscores");
  const eventId = useEventId();
  const teamId = useTeamId();
  const [teams] = useSimpleCollection<Team>(`events/${eventId}/teams`);
  const [event, loadingEvent, errorEvent] = useEvent();

  useEffect(() => {
    if (errorEvent) console.error(errorEvent);
  }, [errorEvent]);

  const [achievements, setAchievements] = useState<Achievement[]>([]);

  useEffect(() => {
    // find out if we're in top 3 in terms of points
    const sortedTeams = teams?.sort((a, b) => b.points - a.points);
    const newAchievements: Achievement[] = [];

    if (sortedTeams && teamId) {
      const teamIndex = sortedTeams.findIndex((team) => team.id === teamId);

      if (teamIndex >= 0 && teamIndex < 3) {
        const place = teamIndex + 1;
        const team = sortedTeams[teamIndex];

        const achievement: PlaceAchievement = {
          place,
          points: team.points ?? 0,
          label: t(`achievements.${place === 1 ? "first" : place === 2 ? "second" : "third"}Place`),
          description: t(`achievements.${place === 1 ? "first" : place === 2 ? "second" : "third"}PlaceDescription`),
        };

        newAchievements.push(achievement);
      }
    }

    setAchievements(newAchievements);
  }, [teams, teamId]);

  const achievementsExist = achievements?.length > 0;

  const isPlayers = event?.mainConfig?.playersOnly ?? false;
  const title = isPlayers ? t("titlePlayers") : t("title");

  return (
    <Loading loading={!event || loadingEvent}>
      <div className="flex h-screen flex-col ">
        <TopNav showBack isAdmin={isAdmin} />
        <main className="overflow-y-scroll">
          <div className="flex flex-col items-center px-8">
            {/* {achievementsExist && <h1 className="mb-8 mt-12 text-center text-3xl font-semibold">{t("achievements")}</h1>} */}
            {/* <AchievementCarousel achievements={achievements} /> */}
            <h1 className="mb-8 mt-12 text-center text-3xl font-semibold">{title}</h1>
            <div className="mb-32 w-full max-w-xl sm:mr-8">
              <HighscoreTable />
            </div>
          </div>
        </main>
        {!isAdmin && <Footer />}
      </div>
    </Loading>
  );
};
